// extracted by mini-css-extract-plugin
module.exports = {"base":"AnimatedGifs_base__xGBF5","body":"AnimatedGifs_body__dj8AY","dividers":"AnimatedGifs_dividers__BYw_u"};